export type BodyView = "Face" | "Dos";

export interface BodyZone {
  key: string;
  label: string;
  fullLabel?: string;
}

export const BODY_ZONES: Record<BodyView, BodyZone[]> = {
  Face: [
    { key: "teteVisage", label: "Tête et visage" },
    { key: "cou", label: "Cou" },
    { key: "epaules", label: "Épaules" },
    { key: "thorax", label: "Thorax" },
    { key: "abdomen", label: "Abdomen" },
    { key: "brasDroite", label: "Bras droit" },
    { key: "brasGauche", label: "Bras gauche" },
    { key: "avantBrasDroit", label: "Avant-bras droit" },
    { key: "avantBrasGauche", label: "Avant-bras gauche" },
    { key: "mains", label: "Mains" },
    { key: "cuisseDroite", label: "Cuisse droite" },
    { key: "cuisseGauche", label: "Cuisse gauche" },
    { key: "jambeDroite", label: "Jambe droite" },
    { key: "jambeGauche", label: "Jambe gauche" },
    { key: "pieds", label: "Pieds" },
  ],
  Dos: [
    { key: "cuirCheveluNuque", label: "Cuir chevelu et nuque" },
    { key: "hautDuDos", label: "Haut du dos" },
    { key: "basDuDos", label: "Bas du dos" },
    { key: "fesses", label: "Fesses" },
    { key: "brasDroitDos", label: "Bras droit", fullLabel: "Bras droit (dos)" },
    { key: "brasGaucheDos", label: "Bras gauche", fullLabel: "Bras gauche (dos)" },
    { key: "avantBrasDroitDos", label: "Avant-bras droit", fullLabel: "Avant-bras droit (dos)" },
    { key: "avantBrasGaucheDos", label: "Avant-bras gauche", fullLabel: "Avant-bras gauche (dos)" },
    { key: "mainsDos", label: "Mains", fullLabel: "Mains (dos)" },
    { key: "arriereCuisseDroite", label: "Cuisse droite", fullLabel: "Cuisse droite (arrière)" },
    { key: "arriereCuisseGauche", label: "Cuisse gauche", fullLabel: "Cuisse gauche (arrière)" },
    { key: "molletDroit", label: "Mollet droit" },
    { key: "molletGauche", label: "Mollet gauche" },
    { key: "plantesPieds", label: "Plantes des pieds" },
  ],
};

// Keys from the previous zone list, still present on older demandes.
const LEGACY_LABELS: Record<string, string> = {
  tete: "Tête",
  poitrine: "Poitrine",
  mainGauche: "Main gauche",
  mainDroite: "Main droite",
  bassin: "Bassin",
  genouGauche: "Genou gauche",
  genouDroite: "Genou droit",
  piedsGauche: "Pied gauche",
  piedsDroite: "Pied droit",
  nuque: "Nuque",
  dosSuperieur: "Dos supérieur",
  dosInferieur: "Dos inférieur",
  fessier: "Fessier",
};

const LABELS: Record<string, string> = {
  ...LEGACY_LABELS,
  ...Object.fromEntries(
    [...BODY_ZONES.Face, ...BODY_ZONES.Dos].map((z) => [
      z.key,
      z.fullLabel || z.label,
    ])
  ),
};

export const getBodyPartLabel = (value: string | null | undefined): string => {
  if (!value || typeof value !== "string") return "";
  if (LABELS[value]) return LABELS[value];
  return value
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ")
    .replace(/^\w/, (char) => char.toUpperCase());
};
